module.exports = __webpack_public_path__ + "img/service1.cb1d76e0.png";